import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import ColoredButton from "../component/ColoredButton";
import InputField from "../component/InputField";
import Loader from "../component/Loader";
import GridModal from "../component/Modals/GridModal";
import SelectDropDown from "../component/SelectDropDown";
import RegistrationService from "../services/registration";
import UploadFile from "../component/UploadFile";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import { validateDoc } from "../constants/commonFunction";
import ProfileService from "../services/Profile";
import ImageContainer from "../component/ImageContainer";
import TierFlow from "../component/TierFlow";
const MyContractorDetails = () => {
  const { contractorId } = useParams();
  const [persona, setPersona] = useState([]);
  const [isTseModalVisible, setIsTseModalVisible] = useState(false);
  const [dealerSelected, setDealerSelected] = useState({
    id: "",
    title: "",
  });
  const [loadingReassignBtn, setLoadingReassignBtn] = useState(false);
  const [dealerOption, setDealerOption] = useState([]);
  const [pan, setPan] = useState("");
  const [panImage, setPanImage] = useState("");
  const [findUserBlock, setFindUserBlock] = useState(false);
  const [allTsos, setAllTsos] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState({
    id: "",
    title: "",
  });
  const [selectedUser, setSelectedUser] = useState({
    full_name: "",
    full_name_dealer: null,
    dealer_id_extern: null,
    phone_number: "",
    id_extern01: "",
    user_hierarchy_id: 0,
    contact_id: 0,
    state_name: "",
    country_name: "",
    district_name: "",
    taluka_name: "",
    addline1: "",
    addline2: "",
    addline3: "",
    dealer_id: null,
    post_code: "",
    marital_status: "",
    spouse_name: "",
    spouse_birthday: "",
    wedding_anniversary: "",
    pan: "",
    panImage: "",
  });
  const [selectedTSE, setSelectedTSE] = useState({
    id: "",
    title: "",
  });
  const [findUserOption, setFindUserOption] = useState([]);
  const [findUser, setFindUser] = useState({
    id: "",
    title: "",
    phoneNo: "",
    country: "",
    state: "",
    district: "",
    taluka: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    postCode: "",
    districtId: "",
    talukId: "",
    brandId: "",
    contactId: "",
  });
  const [dealerValidationError, setDealerCodeValidationError] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentTierData, setCurrentTierData] = useState({});
  const [masterTier, setMasterTier] = useState([
    {
      tierId: 1,
      tier_name: 'Bronze',
      sequence: 1,
      tier_level: 1,
    },
    {
      tierId: 2,
      tier_name: 'Silver',
      sequence: 2,
      tier_level: 2,
    },
    {
      tierId: 3,
      tier_name: 'Gold',
      sequence: 3,
      tier_level: 3,
    },
    {
      tierId: 4,
      tier_name: 'Platinum',
      sequence: 4,
      tier_level: 4,
    },
  ]);
  const [hierName, setHiername] = useState(null);
  const [activityLoader, setActivityLoader] = useState(true);

  function fetchData(token) {
    const hierType = localStorage.getItem('hierCode');
      const conId = JSON.parse(localStorage.getItem('userData')).dcm_contacts_id;
      setHiername(hierType);
      RegistrationService.getMyContractorsTSEDetails(conId).then(
        res => {
          if (res.success) {
            if (hierType == 'TSE' && res.response.userDetails?.length > 0) {
              setSelectedUser(res.response.userDetails[0]);
            }
            if (hierType == 'Dealer' && res.response.dealerDetails?.length > 0) {
              setSelectedUser(res.response.dealerDetails[0]);
            }
            setCurrentTierData(res?.response?.tierDetails);
            setMasterTier(res?.response?.tierDetails?.masterTierData);
          }
        },
      );
  }

  async function fetchData(token) {
    try {
      setActivityLoader(true);
      // const desc = localStorage.getItem('userData');
      const contactId = JSON.parse(localStorage.getItem('userData')).dcm_contacts_id;
      const desc = JSON.parse(localStorage.getItem('userData')).description;
      setHiername(desc);
  
      const res = await RegistrationService.getMyContractorsTSEDetails(contactId);
  
      if (res.success) {
        if (desc === 'TSE' && res.response.userDetails?.length > 0) {
          setSelectedUser(res.response.userDetails[0]);
        }
        if (desc === 'Dealer' && res.response.dealerDetails?.length > 0) {
          setSelectedUser(res.response.dealerDetails[0]);
        }
  
        setCurrentTierData(res?.response?.tierDetails);
        setMasterTier(res?.response?.tierDetails?.masterTierData);
      }
    } catch (error) {
      console.error('Error fetching data:');
    } finally {
      setActivityLoader(false);
    }
  }
  
  useEffect(() => {
   fetchData();
  }, []);
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    const payload = {
      loginUserHirarchy: parseInt(userInfo.dcm_hierarchies_id),
    };
    RegistrationService.listOfTSOs(payload)
      .then((res) => {
        const tsos = res.response.Data[0].map((tso) => {
          return {
            id: tso.id,
            title: `${tso.first_name} ${tso.last_name}`,
          };
        });
        setAllTsos(tsos);
      })
      .catch((err) => {
      });
    const memberTypeResponse = async () => {
      try {
        const selectedOrg = 2;
        const MemberTypeFetch = await RegistrationService.getHierarchies(
          selectedOrg
        );
        if (
          MemberTypeFetch.success === true &&
          MemberTypeFetch.response.hierarchiesDetails.length > 0
        ) {
          const personaDetails =
            MemberTypeFetch.response.hierarchiesDetails.map((item, index) => ({
              id: item.id,
              title: item.name,
            }));
          setPersona(personaDetails);
          setLoading(false);
        }
      } catch (e) {
      }
    };

    memberTypeResponse();
  }, []);

  // Select TSE
  // useEffect(() => {
  //   const TSEDataFetch = async () => {
  //     try {

  //       const token = localStorage.getItem('access_token');
  //       const userInfo = JSON.parse(localStorage.getItem("userData"));
  //       // );
  //       const hierId = userInfo.dcm_hierarchies_id;
  //       const officerId = 'TSE';
  //       const districtId = findUser.districtId;
  //       const talukId = findUser.talukId;
  //       const brandId = findUser.brandId;
  //       const payload = {
  //         userContactId: findUser.id,

  //       };
  //       //  
  //       //  );

  //       const TSEDataResponse = await RegistrationService.getDealersOrTse(officerId, districtId,talukId,brandId,payload,token);

  //       if (TSEDataResponse.success === true && TSEDataResponse.response.adminDetails.length > 0) {
  //        const mappedTSEList = TSEDataResponse?.response?.adminDetails?.map((item, index) => {
  //           return {
  //             id: item.id,
  //             title: item.full_name
  //           };
  //         });

  //         setSelectedTSEList(mappedTSEList);
  //         // setLoading(false)
  //        }

  //     } catch (e) {

  //     }
  //   }
  //   TSEDataFetch();
  // }, [findUser]);

  //Select Dealer
  useEffect(() => {
    const DealerDataFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const payload = {
          userContactId: findUser.id,
        };
        const officerId = "Dealer";
        const districtId = findUser.districtId;
        const talukId = findUser.talukId;
        const brandId = findUser.brandId;
        const DealerDataFetchResponse =
          await RegistrationService.getDealersOrTse(
            officerId,
            districtId,
            talukId,
            brandId,
            payload,
            token
          );
        if (
          DealerDataFetchResponse.success == true &&
          DealerDataFetchResponse.response.adminDetails.length > 0
        ) {
          setDealerOption(
            DealerDataFetchResponse.response.adminDetails.map((item, index) => {
              return {
                id: item?.id,
                title: item?.full_name,
              };
            })
          );
        }
        // setLoading(false)
      } catch (e) {
      }
    };
    DealerDataFetch();
  }, [findUser]);

  const handleDealerChange = (selected) => {
    setDealerSelected(selected);
    setDealerCodeValidationError("");
  };
  const handleInfluAddressChange = (e) => {
    
  };

  function resetFindUser() {
    setFindUser({
      id: "",
      title: "",
      phoneNo: "",
      country: "",
      state: "",
      district: "",
      taluka: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      postCode: "",
      districtId: "",
      talukId: "",
      brandId: "",
      contactId: "",
    });
  }

  async function submitPanHandler() {
    if(!pan || !validateDoc('PAN', pan)) {
      toast.error("Enter a valid PAN number")
      return;
    }
    if(!panImage) {
      toast.error("Enter PAN image")
      return;
    }

    try {
      setLoading(true);
      const payload = {
        identity_number_type: 'pan',
        identity_number: String(pan),
        GSTN: null,
        contact_id: String(selectedUser.contact_id),
        phone: String(selectedUser.phone_number),
      }
      const response = await ProfileService.updateEkycInformation(payload);
      if(response.success) {
        const formData = new FormData();
        if (panImage) {
          formData.append('pan_image', panImage.file);
          formData.append('KYCType', 'pan');
          formData.append('KYCDetails', pan);
          formData.append('contact_id', String(selectedUser.contact_id));
          const responseImage = await ProfileService.uploadEkycDoc(formData);
          if (responseImage.success == true) {
            toast.success(responseImage.response.message);
            fetchData();
          } else {
            setLoading(false);
            toast.error(responseImage.response.message);
          }
        }

      }

    } catch(err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
    
  }

  return (
    <>
      {/* {loading && <Loader />} */}
      <BreadCrumbSecttion
        pageTitle="Influencer Details"
        currentPageName="Influencer Details"
      />
      <section className="padTop50">
        <Container>
          {/* <Row>
                    <Col xs={12} lg={12}>
                      <div className='searchBoxBlock my-4'>
                        <Row>
                        <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Member Type"
                        requiredStar="*"
                        options={persona}
                        onChange={handlePersonaChange}
                        selectedValue={selectedPersona}
                        setSelectedValue={setSelectedPersona}
                        page='searchFilter'
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Find User"
                        requiredStar="*"
                        options={findUserOption}
                        onChange={handleFindUserChange}
                        selectedValue={findUser}
                        setSelectedValue={setFindUser}
                        page='searchFilter'
                      />

                    </Col>
                    {selectTSEOption &&
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Select TSE"
                          requiredStar="*"
                          options={selectedTSEList}
                          onChange={handleTSEChoose}
                          selectedValue={selectedTSE}
                          setSelectedValue={setSelectedTSE}
                        />

                      </Col>}
                        </Row>
                      </div>
                    </Col>
          </Row> */}
          <TierFlow
            tiers={masterTier}
            currentTierId={currentTierData?.currentTierId}
            currentPoints={currentTierData?.currentPoints || 0}
            maxPoints={currentTierData?.maxPoints || 4000}
          />

          {true && (
            <Row className="justify-content-center align-item-center h-100">
              <Col xs={12}>
                <div className="userInfoBox">
                  <div className="dashboard-details influncerFrm">
                    <Row>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Name"
                          editable={false}
                          value={selectedUser.full_name}
                        />
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Phone Number"
                          editable={false}
                          value={selectedUser.phone_number}
                        />
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Marital Status"
                          editable={false}
                          value={selectedUser.marital_status}
                        />
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Country"
                          editable={false}
                          value={selectedUser?.country_name}
                        />
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="State"
                          editable={false}
                          value={selectedUser.state_name}
                        />
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="District"
                          editable={false}
                          value={selectedUser.district_name}
                        />
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Taluka"
                          editable={false}
                          value={selectedUser.taluka_name}
                        />
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Address Line 1"
                          editable={false}
                          value={selectedUser.addline1}
                          onChange={handleInfluAddressChange}
                          // requiredStar="*"
                          name="addressLine1"
                        />
                        {/* {addressLine1ValidationError && (
                          <div className="error-message">
                            {addressLine1ValidationError}
                          </div>
                        )} */}
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Address Line 2"
                          editable={false}
                          value={selectedUser.addline2}
                          name="addressLine2"
                          // requiredStar="*"
                          onChange={handleInfluAddressChange}
                        />
                        {/* {addressLine2ValidationError && (
                          <div className="error-message">
                            {addressLine2ValidationError}
                          </div>
                        )} */}
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Address Line 3"
                          editable={false}
                          value={selectedUser.addline3}
                          name="addressLine3"
                          // requiredStar="*"
                          onChange={handleInfluAddressChange}
                        />
                        {/* {addressLine3ValidationError && (
                          <div className="error-message">
                            {addressLine3ValidationError}
                          </div>
                        )} */}
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          inputFieldLabel="Pincode"
                          editable={false}
                          value={selectedUser.post_code}
                          // requiredStar="*"
                          name="postCode"
                          onChange={handleInfluAddressChange}
                        />
                        {/* {pinCodeValidationError && (
                          <div className="error-message">
                            {pinCodeValidationError}
                          </div>
                        )} */}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Dealer/ARS/Retailer"
                          // requiredStar="*"
                          options={dealerOption}
                          disabled={true}
                          onChange={handleDealerChange}
                          selectedValue={{id: selectedUser.dealer_id, title: selectedUser.full_name_dealer}}
                          setSelectedValue={setDealerSelected}
                          page="searchFilter"
                        />
                        {/* {dealerSelected && (
                          <div className="error-message">
                            {dealerValidationError}
                          </div>
                        )} */}
                      </Col>
                    </Row>
                    <hr/>
                    <Row>
                      <Col xs={12} lg={4}>
                        <InputField
                            inputFieldLabel="PAN"
                            value={selectedUser.pan ? selectedUser.pan : pan}
                            requiredStar="*"
                            name="postCode"
                            setValue={setPan}
                            disabled={(selectedUser.pan || selectedUser.panImage) ? true : false}
                        />
                      </Col>
                      <Col xs={12} lg={8}>
                        {(selectedUser.panImage || selectedUser.pan) ? (selectedUser.panImage ? <ImageContainer image={selectedUser.panImage} /> : <p>PAN image missing</p>) : 
                        <UploadFile                                
                          requiredStar="*"
                          accept="image/*"
                          value={panImage}
                          setValue={setPanImage} />}
                      </Col>
                      {!(selectedUser.panImage || selectedUser.pan) && <Row>
                        <Col xs = {12} xxl = {4}>
                            <PrimaryGradientButton buttonText="Submit PAN Details" onClick={submitPanHandler} disabled={loading} />
                        </Col>
                      </Row>}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </section>
      <GridModal
        hasImage={false}
        title={"TSE/TE"}
        show={isTseModalVisible}
        onHide={() => setIsTseModalVisible(false)}
        data={allTsos}
        selected={selectedTSE}
        setSelected={setSelectedTSE}
      />
    </>
  );
};

export default MyContractorDetails;
